import SamplingRequest from "modules/kizuna/components/SamplingRequest"
import ModalContext from "modules/kizuna/components/SamplingRequest/context"
import PropTypes from "prop-types"
import "./styles/requests-section.scss"

const RequestsSection = ({ modalContext, toggable, toggle }) => {
  return (
    <>
      <ModalContext.Provider value={modalContext ?? ""}>
        <SamplingRequest isOpen={toggable} toggle={toggle} />
      </ModalContext.Provider>
    </>
  )
}

RequestsSection.propTypes = {
  modalContext: PropTypes.object,
  toggable: PropTypes.bool,
  toggle: PropTypes.func
}

export default RequestsSection
